import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    STATUS_USER_UPDATE_REQUEST,
    STATUS_USER_UPDATE_SUCCESS,
    STATUS_USER_UPDATE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateStatusUserAction = (id,data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_FB_BOT}/api/users/${id}/online-status`,
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            STATUS_USER_UPDATE_REQUEST,
            {
                type: STATUS_USER_UPDATE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": STATUS_USER_UPDATE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: STATUS_USER_UPDATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": STATUS_USER_UPDATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateStatusUserAction}